<template>
  <div class="flex w-full" :datepicker="tagName" :class="getClass">
    <vs-row vs-type="flex" vs-w="12">
      <vs-col vs-w="2" class="pr-3">
        <v-select v-model="yearLabel"
                  name="selectbox"
                  :options="selectOptions"
                  :clearable="true"
                  :reduce="option => option.value"
                  :disabled="disabled || typeOfCalender === true"
                  @input="setSelectedYearLabel"
                  >
          <span slot="no-options">該当する選択肢がありません。</span>
        </v-select>
      </vs-col>
      <vs-col vs-w="1" class="fix_width">
        <vs-input type="search" @blur="yearLabelNumber=formatInteger(yearLabelNumber, false); focusOut(); updateYearLabelNumber()" @focus="onFocus('yearLabelNumber')" v-model="yearLabelNumber" 
        name="year" :maxlength="typeOfCalender ? 4 : 2" :disabled="disabled" />
          <span class="tooltip-custom" :class="addPadding('yearLabelNumber')">{{showMaxlengthYeah((typeOfCalender ? 4 : 2), yearLabelNumber, 'yearLabelNumber')}}</span>
      </vs-col>
      <vs-col vs-w="0.5" class="pt-2">
        <span class="mx-2 self-center">年</span>
      </vs-col>
      <vs-col vs-w="1">
        <vs-input type="search" @blur="month=formatInteger(month, false);updateMonth(); focusOut()" @focus="onFocus('month')" v-model="month"  name="month" maxlength="2" :disabled="disabled" />
        <span class="tooltip-custom" :class="addPadding('month')">{{showMaxlength(2, month, 'month')}}</span>
      </vs-col>
      <vs-col vs-w="0.6" class="pt-2">
        <span class="mx-2 self-center" v-if="minimumView !== 'month' || name === 'tatemono_kenchikujikiu' || name === 'tatemono_zokaichikujikan' || name === 'senyububun_kenchikujiki'">月</span> <span class="self-center" v-else>月頃</span>
      </vs-col>
      <vs-col v-if="minimumView !== 'month'" vs-w="1">
        <vs-input type="search" @blur="day=formatInteger(day, false);updateDay(); focusOut()" @focus="onFocus('day')" v-model="day" name="day" maxlength="2" :disabled="disabled" />
        <span class="tooltip-custom" :class="addPadding('day')">{{showMaxlength(2, day, 'day')}}</span>
      </vs-col>
      <vs-col v-if="minimumView !== 'month'" vs-w="0.5" class="pt-2">
        <span class="mx-2 self-center">日</span>
      </vs-col>
      <vs-col vs-w="1" class="px-2 paddingTopCst-6">
        <button class="calendar-icon" @click="openDatepicker" @blur="closeDatepicker" :disabled="disabled" ></button>
        <datepicker v-model="datetime"
                :name="name"
                :language="language"
                :format="format"
                :holidayDates="holidayDateList"
                :minimumView="minimumView"
                :maximumView="maximumView"
                @selected="doSelectedDate"
                :disabled="disabled"
                :disabled-dates="disabledDates"
                ref="picker"
                input-class="hideInput"
                >
      </datepicker>
      </vs-col>
      <vs-col class="checkbox-calendar paddingTopCst-8">
        <vs-checkbox v-model="typeOfCalender" @change="changeTypeOfCalander" :disabled="disabled" >西暦で表示する</vs-checkbox>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker-with-rokuyo'
import { ja } from 'vuejs-datepicker-with-rokuyo/dist/locale'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import moment from 'moment'

export default {
  name: 'DatePickerCustom',
  mixins: [utilitiesMethods],
  components: {
    vSelect,
    Datepicker
  },
  props: ['date', 'disabled', 'format', 'separate', 'name', 'errorClass', 'checkboxvalue', 'cleardate', 'changedate'],
  data() {
    return {
      yearLabel: '',
      yearLabelNumber: '',
      year: '',
      month: '',
      day: '',
      split: '/',
      dateSelected: null,
      datetime: null,
      language: ja,
      minimumView: 'day',
      maximumView: 'year',
      selectOptions: [
        { label: '令和', value: '令和' },
        { label: '平成', value: '平成' },
        { label: '昭和', value: '昭和' },
        { label: '大正', value: '大正' },
        { label: '明治', value: '明治' }
      ],
      disabledDates: {
        to: new Date('01-25-1868')
      },
      tagName: '',
      typeOfCalender: false
    }
  },
  watch: {
    checkboxvalue(val) {
      this.typeOfCalender = val
      this.changeTypeOfCalander()
      this.editYearLabelNumber(val)
      // this.updateYearLabelNumber()
    },
    cleardate(val) {
      if(+val > 0) {
        this.yearLabel = ''
        this.yearLabelNumber = ''
        this.year = ''
        this.month = ''
        this.day = ''
        this.dateSelected = ''
      }
    },
    changedate(val) {
      if(val) {
        this.dateSelected = val
        this.bindDate()
      } else {
        this.yearLabel = ''
        this.yearLabelNumber = ''
        this.year = ''
        this.month = ''
        this.day = ''
        this.dateSelected = ''
      }
    }
  },
  mounted() {
    const vm = this
    if (['MM/yyyy', 'yyyy/MM', 'yyyy-MM', 'MM-yyyy'].includes(this.format)) {
      this.minimumView = 'month'
      this.maximumView = 'year'
    }
    if (this.separate) {
      this.split = this.separate
    }
    this.tagName = this.name
    vm.$nextTick(function () {
      vm.dateSelected = vm.date
      vm.typeOfCalender = vm.checkboxvalue
      vm.bindDate()
      vm.$emit('init')
    })
    this.clearTitleButton()
  },
  methods: {
    clearTitleButton() {
      const ele = document.getElementsByClassName('vs__clear')
      for(let i = 0; i < ele.length; i++) {
        ele[i].title = ''
      }
    },
    editYearLabelNumber(val) {
      if(!val && (this.yearLabelNumber > 99  || this.yearLabelNumber < 0)) {
        this.yearLabelNumber = 99
      }
      if(isNaN(this.yearLabelNumber)) {
        this.yearLabelNumber = 99
      }
    },
    bindDate() {
      // eslint-disable-next-line no-extra-boolean-cast
      if(!!this.dateSelected) {
        const splitedDate = this.dateSelected.split(this.split)
        if (splitedDate.length === 3) {
          this.year = splitedDate[0]
          this.month = splitedDate[1]
          this.day = splitedDate[2]
        }
        if(!this.typeOfCalender) {
          this.yearLabel = this.calculateYearLabel(this.dateSelected)
          this.yearLabelNumber = this.calculateYearLabelNumber(this.yearLabel, +this.year)
          if(this.yearLabelNumber > 99) {
            this.yearLabelNumber = 99
          }
        } else {
          this.yearLabel = ''
          this.yearLabelNumber = this.year
        }
      } else {
        this.yearLabelNumber = ''
      }
      if (moment(this.dateSelected, this.format ? this.format : 'YYYY-MM-DD').isValid()) {
        this.datetime = this.dateSelected
      } else {
        this.datetime = null
      }
      this.clearTitleButton()
    },
    setSelectedYearLabel(value) {
      if(!this.typeOfCalender && !!this.yearLabelNumber && !!this.yearLabel) {
        const yearNumber = this.setYearNumber(value)
        this.year = this.yearLabelNumber - 1 + yearNumber
      } else if(this.typeOfCalender && !!this.yearLabelNumber) {
        this.year = this.yearLabelNumber 
      } else {
        this.year = ''
      }
      this.formatDateWithSplit().then((date) => {
        this.dateSelected = date
        this.$emit('input', this.dateSelected)
        this.lostFocusDate()
      })
    },
    updateYearLabelNumber() {
      if(!this.typeOfCalender && !!this.yearLabelNumber && !!this.yearLabel) {
        const yearNumber = this.setYearNumber(this.yearLabel)
        this.year = this.yearLabelNumber - 1 + yearNumber
      } else if(this.typeOfCalender && !!this.yearLabelNumber) {
        this.year = this.yearLabelNumber 
      } else {
        this.year = ''
      }
      this.formatDateWithSplit().then((date) => {
        this.dateSelected = date
        this.$emit('input', this.dateSelected)
        this.lostFocusDate()
      })
    },
    updateMonth() {
      this.formatDateWithSplit().then((date) => {
        this.dateSelected = date
        this.$emit('input', this.dateSelected)
        this.lostFocusDate()
      })
    },
    updateDay() {
      this.formatDateWithSplit().then((date) => {
        this.dateSelected = date
        this.$emit('input', this.dateSelected)
        this.lostFocusDate()
      })
    },
    openDatepicker() {
      this.$refs.picker.showCalendar()
      this.lostFocusDate()
    },
    closeDatepicker() {
      this.$refs.picker.close()
    },
    doSelectedDate(val) {
      const yearSelected = this.formatDate(val).split(this.split)[0]
      this.year = yearSelected
      this.month = this.formatDate(val).split(this.split)[1]
      this.day = this.formatDate(val).split(this.split)[2]
      const mergedDate = `${this.year}-${this.month}-${this.day}`
      if(this.minimumView === 'month' && +this.year === 1989 && +this.month === 1) {
        this.day  =  1
        this.dateSelected  = this.formatDateWithDay(val, 1)
      } else if(this.minimumView === 'month' && +this.year === 1868 && +this.month === 1) {
        this.day  =  25
        this.dateSelected  = this.formatDateWithDay(val, 25)
      }else if(this.minimumView === 'month') {
        this.day  =  15
        this.dateSelected  = this.formatDateWithDay(val, 15)
      } else {
        this.dateSelected = this.formatDate(val)
      }
      if(!this.typeOfCalender) {
        this.yearLabel = this.calculateYearLabel(mergedDate)
        this.yearLabelNumber = this.calculateYearLabelNumber(this.yearLabel, +yearSelected)
      } else {
        this.yearLabelNumber = this.year
      }
      this.$emit('input', this.dateSelected)
      this.lostFocusDate()
    },
    formatDate(date) {
      const d = moment(date, this.format)
      let month = `${  d.month() + 1}`
      let day = `${  d.date()}`
      const year = d.year()
      if(month.length < 2) {
        month = `0${  month}`
      }
      if(day.length < 2) {
        day = `0${  day}`
      }
      return [year, month, day].join(this.split)
    }, 
    formatDateWithDay(date, dayNumber) {
      const d = moment(date, this.format)
      let month = `${  d.month() + 1}`
      let day = `${  dayNumber}`
      const year = d.year()

      if(month.length < 2) {
        month = `0${  month}`
      }
      if(day.length < 2) {
        day = `0${  day}`
      }
      return [year, month, day].join(this.split)
    },
    formatDateWithSplit() {
      const self = this
      return new Promise(resolve => {
        if(self.month.length < 2) {
          self.month = self.month || String(self.month) === '0' ? `0${self.month}` : ''
        }
        if(self.day.length < 2) {
          self.day = self.day || String(self.day) === '0' ? `0${self.day}` : ''
        }
        let result = ''
        if (this.minimumView === 'month' && !isNaN(parseInt(self.year)) && !isNaN(parseInt(self.month))) {
          if (parseInt(self.month) === 1 && ((!self.typeOfCalender && self.yearLabel === '昭和' && parseInt(self.yearLabelNumber) === 64) || 
            (self.typeOfCalender && parseInt(self.yearLabelNumber) === 1989))) {
            result = [self.year, self.month, '01'].join(this.split)
          }else if (parseInt(self.month) === 7 && ((!self.typeOfCalender && self.yearLabel === '大正' && parseInt(self.yearLabelNumber) === 1))) {
            result = [self.year, self.month, '30'].join(this.split)
          }else if (parseInt(self.month) === 12 && ((!self.typeOfCalender && self.yearLabel === '昭和' && parseInt(self.yearLabelNumber) === 1))) {
            result = [self.year, self.month, '25'].join(this.split)
          }else if (parseInt(self.month) === 1 && ((!self.typeOfCalender && self.yearLabel === '明治' && parseInt(self.yearLabelNumber) === 1) || 
            (self.typeOfCalender && parseInt(self.yearLabelNumber) === 1868))) {
            result = [self.year, self.month, '25'].join(this.split)
          } else {
            result = [self.year, self.month, '15'].join(this.split)
          }
        } else if (!isNaN(parseInt(self.year)) && !isNaN(parseInt(self.month)) && !isNaN(parseInt(self.day))) {
          result = [self.year, self.month, self.day].join(this.split)
        }
        if(result) {
          this.dateSelected = result
          this.bindDate(result)
        } else {
          this.datetime = result
        }
        resolve(result)
      })
    },
    isEmptyInputText() {
      return this.year === '' || this.month === '' || this.day === ''
    },
    isValidYearLabelNumber() {
      return +this.yearLabelNumber > 0
    },
    isValidMonth() {
      return +this.month > 0 && +this.month <= 12
    },
    isValidDay() {
      return +this.day > 0 && +this.day <= 31
    },
    isValidDate(value) {
      return moment(value, this.separate).isValidDate()
    },
    lostFocusDate() {
      this.$nextTick(() => this.$emit('lost-focus'))
    }, 
    changeTypeOfCalander() {
      if(this.typeOfCalender) {
        this.yearLabel = ''
      }
      if(this.dateSelected) {
        if(this.typeOfCalender) {
          this.yearLabel = ''
          this.yearLabelNumber = this.year
        } else {
          const date = moment(this.dateSelected, this.format)
          const yearSelected = date.year()
          const mergedDate = `${+yearSelected}-${this.month}-${this.day}`
          this.yearLabel = this.calculateYearLabel(mergedDate)
          const tmpYearLableNumber = this.calculateYearLabelNumber(this.yearLabel, +yearSelected)
          // this.yearLabelNumber =  this.yearLabel === '昭和' ? (+yearSelected - 1926 + 1) : this.yearLabel === '平成' ? (+yearSelected - 1989 + 1) : (+yearSelected - 2019 + 1)
          if(tmpYearLableNumber < 0) {
            this.yearLabel = ''
            this.yearLabelNumber = yearSelected
          } else {
            this.yearLabelNumber = tmpYearLableNumber
          }
        }
      }
      this.$emit('change-checkbox', this.typeOfCalender)
    },
    setYearNumber(label) {
      let yearNumber = 0
      if(label === '令和') {
        yearNumber = 2019
      }else if(label === '平成') {
        yearNumber = 1989
      }else if (label === '昭和') {
        yearNumber = 1926
      }else if (label === '大正') {
        yearNumber = 1912
      }else{
        yearNumber = 1868
      }
      return yearNumber
    },
    calculateYearLabel(date) {
      if(new Date(date) < new Date('1912-07-30')) {
        return '明治'
      }else if(new Date(date) < new Date('1926-12-25')) {
        return '大正'
      }else if (new Date(date) < new Date('1989-01-08')) {
        return '昭和'
      }else if (new Date(date) < new Date('2019-05-01')) {
        return '平成'
      }else{
        return '令和'
      }
    },
    calculateYearLabelNumber(yearLabel, yearNumber) {
      if(yearLabel === '明治') {
        return yearNumber - 1868 + 1
      }else if(yearLabel === '大正') {
        return yearNumber - 1912  + 1
      }else if(yearLabel === '昭和') {
        return yearNumber - 1926 + 1
      }else if(yearLabel === '平成') {
        return yearNumber - 1989 + 1
      }else {
        return yearNumber - 2019 + 1
      }
    }
  },
  computed: {
    holidayDateList() {
      return this.$store.state.keiyaku.holidays
    },
    getClass() {
      return this.errorClass ? this.errorClass : ''
    }
  }
}
</script>

<style>
.calendar-icon {
  height: 24px;
  width: 24px;
  background: url('../assets/images/baikei/datapicker.png') no-repeat;
  border: none;
  background-size: contain;
  background-position: center;
  cursor: pointer;
}
.checkbox-calendar{
  width: 136px !important;
}
.hideInput {
 display: none !important;
}
.vdp-datepicker__calendar {
 right: 0px;
 top: 10px;
}
.vs__selected-options {
  overflow: hidden;
  text-overflow: ellipsis;
  height: 31px;
}
.vs__selected {
  white-space: nowrap;
}
.is-warning /deep/ .vs__selected-options {
  background-color: rgb(255 197 54 / 60%);
}
.is-warning /deep/ input[name='year'] {
  background-color: rgb(255 197 54 / 60%);
}
.is-warning /deep/ input[name='month'] {
  background-color: rgb(255 197 54 / 60%);
}
.is-warning /deep/ input[name='day'] {
  background-color: rgb(255 197 54 / 60%);
}
.paddingTopCst-6{
  padding-top: 6px !important;
}
.paddingTopCst-8{
  padding-top: 8px !important;
}
.is_parent_fix_width .fix_width{
  min-width: 75px !important;
}

[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
  height: 14px;
  width: 14px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLXggdy00IGgtNCBtdC0xIj48bGluZSB4MT0iMTgiIHkxPSI2IiB4Mj0iNiIgeTI9IjE4Ij48L2xpbmU+PGxpbmUgeDE9IjYiIHkxPSI2IiB4Mj0iMTgiIHkyPSIxOCI+PC9saW5lPjwvc3ZnPg==");
  background-size: 14px 14px;
}
</style>
